module.exports = __webpack_public_path__ + "media/recipes/14-09a2cf4b.png";